import {flow, get, ifThen, isFilled} from '@logistics-frontend/utils'

import type {AddressSuggestResponse, PointAddress} from '../types'
import {fromSuggestToPointAddress} from './from-suggest-to-point-address'

export const fromPinDropToPointAddress: (response: AddressSuggestResponse) => PointAddress | undefined = flow(
  get('suggest[0].__origin'), //
  ifThen(isFilled, fromSuggestToPointAddress),
)
